import { HttpClient } from '#client/http/index'
import { AreaId, AreaDetail } from '#client/resources/index'

export const get = async (
  { httpClient }: { httpClient: HttpClient },
  id: AreaId,
) => {
  const data: AreaDetail = await httpClient.get(`/user/areas/${id}`)
  return data
}
